<template>
  <div>
      <div v-if="!loading" >
        <van-index-bar  :index-list="ABCList"  highlight-color="black"   z-index:999    >
          <div v-for="(item,name) in list" :key="name" >
            <van-index-anchor :index="name"   :scrollTo="name"    >
              <div class="letterStyle"  >{{name}}</div>
            </van-index-anchor>
            <div class="Phonelist border-bottom " style=";padding:0px 16px" v-for="(val,index) in item" :key="index" @click="ToUser(val.userId)">
              <headImage :data="val"   ></headImage>
            </div>
          </div>
        </van-index-bar>
      </div>
      <van-divider v-if="noinfo" :style="{ color: '#009100', borderColor: '#009100', padding: '0 16px' }">{{finishedText}}  </van-divider>
      <van-loading size="26px"  class="mt-3" type="circular" color="#028700" v-if="loading"  vertical></van-loading>
  </div>
</template>

<script>
import {GetInfo,UserList,logout,logout_url} from'@/network/common'
import {debounce} from "@/assets/utils";
import headImage from "@/views/home/components/headImage";
export default {
  name:'userModule',
  props:{
    queryParams:{
      type:Object,
      default:null
    }
  },
  data(){
    return{
      title:'',
      SearchValue:'',
      userInfo:'',//用户信息
      finishedText:'请您搜索进行查询',
      noinfo:false,
      indexList:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','#'],
      loading:false,
      listInfo:null,//数据
      list: [],
      isWx:false,

    }
  },
  components:{headImage},
  watch:{
    // queryParams(item){
    //   console.log('进来了')
    //   this.SearchUser()
    // },
    // 'queryParams.nickName'(){
    //   // console.log('查询进来了')
    //   this.SearchUser()
    // },
   // 'queryParams.userType'(){
   //   console.log('类型变换进来了',this.queryParams)
   //   this.SearchUser()
   // },

    "$route.query.deptId"(){
      if(!this.$route.query.id){
        // console.log(this.$route.query.id)
        // console.log('url地址变了',this.queryParams)
        this.queryParams.deptId=this.$route.query.deptId
        this.getList()
      }
    }

  },
  created(){
    this.getList()
  },
  methods: {

    getList(){
      this.loading=true
      UserList(this.queryParams).then(res=>{
        if(res.code==200 && res.rows!=null){

          if(res.rows.length==0||res.rows==null ){
            this.noinfo=true
            // console.log('进来这里了1')
            if(this.queryParams.nickName==undefined){
              this.finishedText="此部门没有学生通讯录信息"
            }else{
              this.finishedText="未搜到与'"+this.queryParams.nickName+"'相关的"+this.tabsName +"通讯录"
            }
            this.list=[]
            this.listInfo=[]
            this.loading=false
            // console.log('进来这里了2',this.list)
            return
          }else{
            this.list=[]
            this.listInfo=[]
            this.loading=false
            this.finishedText="没有更多了"
          }
          this.noinfo=false //关闭查询
          this.listInfo=res.rows
          if(this.listInfo && this.queryParams.type==1){this.transform()} //字母处理

        }
      })
    },
    SearchUser: debounce(function (type) {
    this.getList()
    }, 500, false),
// ********************

    ToUser(id){
      this.$router.push({path:'/user', query:{id:id}})
    },
    //数据转化成带abc新数组
    transform(){
      let list ={}
      this.indexList.forEach(val=>{
        list[val]=[]
        this.listInfo.forEach(el=>{
          if(el.allPinyin==null){el.allPinyin='#'}
          let first =el.allPinyin.substring(0,1).toUpperCase()
          if(first == val){
            list[val].push(el)
          }
        })
      })
      //  this.$nextTick(()=>{ //强行渲染
      const newlist = this.filterParams(list)
      this.loading=false
      this.list = newlist;
      // })
    },

// 如果对象的每一项为空则删除该项
    filterParams(obj){
      let _newPar = {};
      for (let key in obj) {
        //如果对象属性的值不为空，就保存该属性（，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
        if ((obj[key] === 0 || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
          //记录属性
          _newPar[key] = obj[key];
        }
      }
      //返回对象
      return _newPar;
    },

// ********************
    tabsChange(){
      this.SearchUser()

    },

    back(){
      this.$router.back(-1)
    }


  },
  computed:{
    ABCList(){
      const abc = Object.keys(this.list);
      return abc
    },
    tabsName(){
      let name =''
      if(this.activeName==1){
        name ="个人"
      }else if(this.activeName==2){
        name ="班级"
      }else if(this.activeName == 3){
        name ="单位"
      }

      return name
    }
  }

}
</script>

<style>
.index{font-size: 14.5px;}
.navBar{
  background-color: rgb(0 145 0) ;
  color: white!important;;
}
.index .van-nav-bar .van-icon{
  color: white;
}
.index .van-nav-bar__title{color: white;}
.index .van-nav-bar__text{color: white;}
.index .van-search__content {background-color: rgb(245, 245, 245);}
.hoverActive:hover{
  background-color: rgb(245, 245, 245);
}
.search .van-search__action{
  padding:0px
}
.index .van-index-bar__index{
  line-height:20px;
  font-size:13px
}
.index .Phonelist {line-height:25px !important}
.letterStyle{
  background-color: rgb(241, 241, 241);
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  padding:0px 0px  0px  15px;
  margin: 0px -16px 0px -16px;
}
.TSlabel{
  font-size:13px;
  color: white;
  padding: 1px;
}
</style>

